(function ($, Cobalt, undefined) {
    Cobalt.TagField = function ($tagField) {

        var that = this;
        this.tagsField = $tagField;
        this.newTagField = $("<input>")
                            .attr("type", "text")
                            .attr("name", "newtagfield")
                            .attr("placeholder", $tagField.attr("placeholder"))
                            .addClass("tags-field")
                            .attr("data-each-validation-length-message", this.tagsField.attr("data-each-validation-length-message"))
                            .attr("data-each-validation-length", this.tagsField.attr("data-each-validation-length"));

        this.autoCompleteMenu = null;
        this.hasAutoComplete = false;
        this.addCurrentTags = function () {
            var tags = that.tagsField.val();
            var tagValues = tags.split(',');
            $(tagValues).each(function (i, val) {
                if (val != "") {
                    that.addTag(val);
                }
            });
        };

        this.appendTag = function (text) {
            that.newTagField.val("");
            if (that.autoCompleteMenu != null) {
                $(".modal.tag-autocomplete").hide();
                that.hasAutoComplete = false;
            }
            if (text == "") {
                return;
            }
            if (that.tagsField.val().length > 0) {
                var valsArr = that.tagsField.val().split(",");
                for (var i = 0; i < valsArr.length; i++) {
                    if (valsArr[i] == text) {
                        return;
                    }
                }
                that.tagsField.val(that.tagsField.val() + "," + text);
            }
            else {
                that.tagsField.val(text);
            }
            that.addTag(text);
        };

        this.addTag = function (text) {
            var tagsElem = that.newTagField.parent().find(".tags-cloud");
            if (tagsElem.length <= 0) {
                tagsElem = $("<ul>").addClass("flat-list").addClass("tags-cloud");
                var tagsContainer = $("<div>").addClass("tag-cloud").append(tagsElem);
                $(that.newTagField).parent().append(tagsContainer);
            }
            var tagRemove = $("<a>").attr("href", "#").addClass("tag-remove").text("remove");
            var tagSpan = $("<span>").addClass("tag-text").html(text);
            var tagItem = $("<li>").addClass("tag");
            tagItem.append(tagRemove).append(tagSpan);
            tagRemove.click(function (event) {
                var currentTagsVal = that.tagsField.val();
                var valsArr = currentTagsVal.split(',');
                var newValsArr = new Array();
                var tagText = $(this).siblings(".tag-text").text();

                for (var i = 0; i < valsArr.length; i++) {
                    if (valsArr[i] != tagText) {
                        newValsArr.push(valsArr[i]);
                    }
                }
                that.tagsField.val(newValsArr.join(','));
                if (that.tagsField.val() == '') {
                    tagItem.parent().remove();
                }
                else {
                    tagItem.remove();
                }
                event.preventDefault();
            });

            tagsElem.append(tagItem);
        };
        var attr = this.tagsField.attr("data-each-validation-length");
        var range = attr.split('..');
        var dataMinLength = range[0];
        var dataMaxLength = range[1];
        var parentForm = this.tagsField.parents("form");
        this.tagsField.parent().append(this.newTagField);
        this.tagsField.removeAttr("data-validation-optional").removeAttr("data-each-validation-length").removeAttr("maxlength");

        if (parentForm.length > 0) {
            parentForm.submit(function (event) {
                var text = that.newTagField.val();
                if (that.newTagField.valid()) {
                    that.appendTag(text);
                }
            });
        }

        this.newTagField.keydown(function (event) {
            if (event.which == 13) {
                if (!that.hasAutoComplete) {
                    var text = $(this).val();
                    if ($(this).valid()) {
                        $(this).val("");
                        that.appendTag(text);
                    }
                    else {
                        if (text == "") {
                            var errors = { "Errors": {} };
                            errors.Errors[$(this).attr("id")] = [L.Global.ErrorMessages.TagEmpty()];
                            Cobalt.Forms.displayErrors(parentForm, errors.Errors);
                        }
                    }
                }
                event.preventDefault();
            }
        });

        this.addCurrentTags();
        this.tagsField.hide();
        this.autoCompleteMenu = this.newTagField.autocomplete(Cobalt.Routes.Instance.TagAjaxGetTags(), {
            minChars: 3,
            scroll: false,
            dataType: 'json',
            selectFirst: false,
            parse: function (data) {
                var rows = new Array();
                if (data) {
                    for (var i = 0; i < data.length; i++) {
                        rows[i] = { data: data[i], value: data[i].ID, result: data[i].Text };
                    }
                }
                return rows;
            },
            highlight: function (value, searchTerm) {
                that.hasAutoComplete = true;
                return value.replace(searchTerm, "<strong>" + searchTerm + "</strong>");
            },
            formatItem: function (row) {
                var resultDiv = $("<div>").html(row.Text);
                return resultDiv.html();
            },
            resultsClass: 'modal tag-autocomplete'
        }).result(function (evt, data, formatted) {
            that.appendTag(data.Text);
        }).hideResults(function () {
            that.hasAutoComplete = false;
        });
    };

    Cobalt.Tags = {
        tagsField: null,
        newTagField: null,
        autoCompleteMenu: null,
        hasAutoComplete: false,
        initialize: function () {

            Cobalt.runOnHtmlInsert(function () {
                var tags = $("input.j-tags-field");

                tags.each(function () {
                    var tagField = $(this);
                    if (tagField.data("CobaltTagInit") != null) { // Ensures that the tag system does not initialize more than once per form field element.
                        return;
                    }
                    tagField.data("CobaltTagInit", true)
                    $.extend(tagField, new Cobalt.TagField(tagField));
                });
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Tags.js